import {Controller} from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['form']

  openMailer(event) {
    window.location.href = event.currentTarget.getAttribute('data-mail-to');

    setTimeout(() => {
      this.formTarget.classList.remove('hidden');
    }, 5000);
  }
}